import { Observable } from 'rxjs';
import * as g from './../globals';
import { HttpClient } from '@angular/common/http';
import { Injectable, EventEmitter } from '@angular/core';
import { FieldValueChangedArgs } from '../layout/field-value-changed-args';
import { ExecuteQueryJsonResult } from '@app/models/execute-query-json-result';

@Injectable({
  providedIn: 'root',
})
export class BillOfMaterialService {
  baseUrl = g.baseUrl;
  apiUrl = g.apiBaseUrl;
  addLineEmitter: EventEmitter<any> = new EventEmitter();
  deleteLineEmitter: EventEmitter<any> = new EventEmitter();
  lineAddedEmitter = new EventEmitter();
  constructor(private http: HttpClient) {}

  loadBomChilds(itemCode) {
    return this.http.get(
      g.apiBaseUrl + 'Expose/LoadBomChilds?id=2451&itemCode=' + itemCode
    );
  }
  loadBulkBomChildren(
    itemCodes: string[]
  ): Observable<{ [key: string]: ExecuteQueryJsonResult }> {
    return this.http.post<{ [key: string]: ExecuteQueryJsonResult }>(
      g.apiBaseUrl + 'Expose/LoadBulkBomChildren',
      itemCodes
    );
  }
}
